import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ISignatureConfig } from 'interfaces-lib';
import { DocusignTabComponent } from '../../../components/workflow-config/docusign-tab/docusign-tab.component';
import { ISignatureFormGroupService } from '../../../interfaces/isignatureproviderservice';

@Injectable({
  providedIn: 'root',
})
export class DocusignFormGroupService implements ISignatureFormGroupService {
  buildForm(signatureConfig?: any, combinedOutputDefault?: boolean): UntypedFormGroup {
    return DocusignTabComponent.buildForm(signatureConfig, combinedOutputDefault);
  }

  getFormValue(formGroup: UntypedFormGroup): ISignatureConfig {
    return DocusignTabComponent.getFormValue(formGroup);
  }
}
